import { render, staticRenderFns } from "./AdminDash.vue?vue&type=template&id=1d9d5fe0&"
import script from "./AdminDash.vue?vue&type=script&lang=js&"
export * from "./AdminDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports